import type { ApiClient } from '../ApiClient';
import type { PaginationParams } from '../types/api.types';

/** What every class of `ApiService` shares: the client, the version path and the query of a list. */
export abstract class AApi {
    public constructor(
        protected readonly Client: ApiClient,
        protected readonly VersionPath: string
    ) {}

    /** `?page=…` for a list, empty without any parameter; `filter` adds what the list filters by. */
    protected toQuery(params?: PaginationParams, filter?: Record<string, number>): string {
        const Search = new URLSearchParams();
        if (params?.page !== undefined) {
            Search.set('page', params.page.toString());
        }
        if (params?.per_page !== undefined) {
            Search.set('per_page', params.per_page.toString());
        }
        if (params?.sort !== undefined) {
            Search.set('sort', params.sort);
        }
        if (params?.dir !== undefined) {
            Search.set('dir', params.dir);
        }
        if (params?.q !== undefined) {
            Search.set('q', params.q);
        }
        if (params?.ids !== undefined) {
            Search.set('ids', params.ids);
        }
        for (const [Key, Value] of Object.entries(filter ?? {})) {
            Search.set(Key, Value.toString());
        }
        const Query = Search.toString();

        return Query === '' ? '' : `?${Query}`;
    }
}
